// extracted by mini-css-extract-plugin
export default {"mainHeader":"BecomeASupplier_mainHeader__i9UPa","hero":"BecomeASupplier_hero__-SgMH"};